import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../redux/store'
import { useCallback } from 'react';
import { logout as userLogout } from '../redux/slices/session'
import { useNavigate } from 'react-router-dom';
import { centsClient } from '../api/cents/clients/cents-client';

interface UseAuth {
  isAuthenticated: boolean
  logout: () => Promise<void>
}

export const useAuth = (): UseAuth => {
  const username = useSelector((state: RootState) => state.auth.username)
  const dispatch: AppDispatch = useDispatch()
  const navigate = useNavigate()
  const logout = useCallback(async () => {
    void centsClient.auth.logout()
    // TODO: Wait logout call to finish
    // Logout also if the api call fails
    dispatch(userLogout())
    navigate('/login');
  }, [dispatch])
  // TODO: implement here controls on token

  return {
    isAuthenticated: !!username,
    logout
  }
}
